(function () {
  const collapsibleDescription = () => {
    const collapsibleBlocks = document.querySelectorAll('.collabsible_description');
    
    collapsibleBlocks.forEach((block) => {
      const collapsibleText = block.querySelector('.collapsible_text');
      const expandedBtn = block.querySelector('.collapsible_description_btn');
      
      if (collapsibleText && expandedBtn) {
        const newBtn = expandedBtn.cloneNode(true);
        expandedBtn.parentNode.replaceChild(newBtn, expandedBtn);
        
        newBtn.addEventListener('click', () => {
          collapsibleText.classList.toggle('expanded');
        });
      }
    });
  };

  document.addEventListener("DOMContentLoaded", collapsibleDescription);
  document.addEventListener("shopify:section:load", collapsibleDescription);
})();
